import { getSavedState } from './localStorage';

export const isAuthenticated = () => {
  const EMSUser = getSavedState("EMSUser");
  return EMSUser && Object.keys(EMSUser).length > 0;
};
